export default "/images/vendor/flag-icons/flags/1x1/mo.svg?fe788ad8056f3fae82ab37c0a56a18fb";